import { ResultsItem, ResultSubItem, IconContent } from '../../../features/Report';
import { Tooltip, Table, CopyButton, VisitorsWorldMap } from '../../../components';

export const TrafficSection = ({ id, data }) => {
  const defaultCriteria = {
    status: 'info',
    iconType: 'info',
    importance: { level: 0, text: '' },
    solvability: { level: 0, text: '' },
    isEmpty: true,
    message: 'Data is unavailable.',
    data: null,
  };

  const trafficRank = data?.trafficRank || defaultCriteria;
  const visitorsLocalization = data?.visitorsLocalization || defaultCriteria;
  const errorCount = data?.errorCount || 0;
  const toImproveCount = data?.toImproveCount || 0;

  const visitorsRows = visitorsLocalization?.data?.rows || [];
  const mapData = visitorsLocalization?.data?.mapData || [];

  const visitorsLocalizationTableData = visitorsRows.length > 0
    ? [
        ['Popular Country', 'Domain', 'Status'],
        ...visitorsRows.map((r) => [r?.countryName || '', r?.domain || '', r?.statusText || '']),
      ]
    : [['Popular Country', 'Domain', 'Status']];

  return (
    <ResultsItem 
      id={id}
      title="Traffic" 
      tooltip="It's good to keep tabs on where your site traffic is coming from. This can show you who your website is reaching, and where your audience resides. Your traffic rank shows your website's popularity in the world, and your visitor localization gives you information on the other countries where your website is popular."
      errorCount={errorCount}
      toImproveCount={toImproveCount}
    >
      <ResultSubItem
        title="Traffic Rank"
        tooltip="Your traffic rank shows the popularity of your website."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={trafficRank?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!trafficRank?.isEmpty && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <p className="text-primary">
                  <span className="text-strong">{trafficRank?.data?.globalOrdinal || ''}</span> most visited website in <span className="text-strong">the World</span>
                </p>
                <p className="text-secondary">
                  <span className="text-strong">{trafficRank?.data?.tldOrdinal || ''}</span> most visited website in <span className="text-strong">{trafficRank?.data?.tldLabel || ''}</span>
                </p>
              </div>
            )}
            
            {trafficRank?.isEmpty && (
              <p className="text-primary">{trafficRank?.message || 'No Traffic Rank was not able to be generated.'}</p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Visitors Localization"
        tooltip="Your visitor localization breaks down where in the world your traffic comes from."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={visitorsLocalization?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!visitorsLocalization?.isEmpty && (
              <div className="table-content-wrapper">
                {Array.isArray(mapData) && mapData.length > 0 && (
                  <VisitorsWorldMap data={mapData} />
                )}
                <Table
                  data={visitorsLocalizationTableData}
                  className="table-visitors-localization"
                  id="visitors-localization-table"
                />
                <div className="copy-button-wrapper">
                  <CopyButton targetSelector="#visitors-localization-table" />
                </div>
              </div>
            )}
            
            {visitorsLocalization?.isEmpty && (
              <p className="text-primary">{visitorsLocalization?.message || 'No visitors localization were found.'}</p>
            )}
          </IconContent>
        }
      />
    </ResultsItem>
  );
};
